import {ValueObject} from '@s-ui/domain'

export class NavigationLinksValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.backUrl
   * @param {Number} deps.currentPosition
   * @param {String} deps.nextUrl
   * @param {String} deps.prevUrl
   */
}
